export const FETCH_CUSTOMER_REQUEST = "FETCH_CUSTOMER_REQUEST";
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAIL = "FETCH_CUSTOMER_FAIL";

export const CUSTOMER_ADD_REQUEST = "CUSTOMER_ADD_REQUEST";
export const CUSTOMER_ADD_SUCCESS = "CUSTOMER_ADD_SUCCESS";
export const CUSTOMER_ADD_FAIL = "CUSTOMER_ADD_FAIL";

export const FETCH_BY_PHONE_NUMBER_CUSTOMER_REQUEST = "FETCH_BY_PHONE_NUMBER_CUSTOMER_REQUEST";
export const FETCH_BY_PHONE_NUMBER_CUSTOMER_SUCCESS = "FETCH_BY_PHONE_NUMBER_CUSTOMER_SUCCESS";
export const FETCH_BY_PHONE_NUMBER_CUSTOMER_FAIL = "FETCH_BY_PHONE_NUMBER_CUSTOMER_FAIL";

export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";